import { render, staticRenderFns } from "./Recipe_deck.vue?vue&type=template&id=4dad5ede&scoped=true&"
import script from "./Recipe_deck.vue?vue&type=script&lang=js&"
export * from "./Recipe_deck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dad5ede",
  null
  
)

export default component.exports